import i18n from "@/common/i18n";
// 邀请人数导出字段选择弹窗
import Vue from 'vue';
import useCustomMessageBox from './useCustomMessageBox.js';

const DEFAULT_EXPORT_FIELDS = [
  'nickname',
  'joinId',
  'num',
  'watchDuration',
  'liveWatchDuration',
  'vodWatchDuration',
  'client',
  'location',
  'inviteType',
  'enterTime',
  'channelName'
];

const MessageBoxConent = Vue.extend({
  props: {
    // 打开弹窗时的时间戳,用于监听变化
    openTs: Number
  },
  watch: {
    openTs: {
      handler(newVal) {
        if (newVal) {
          this.formData.export_fields = getExportFields();
        }
      },
      immediate: true
    }
  },
  data() {
    const validateFields = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error(`${i18n.t("lang.k_058001")}`));
      } else {
        callback();
      }
    };
    return {
      formData: {
        // 导出字段
        export_fields: DEFAULT_EXPORT_FIELDS
        // nickname: true, // 原用户名(实际是昵称)
        // nicknameUpdated: false, // 修改后的用户名(实际是昵称)
        // wechatOpenId: false, // 微信OpenID
        // joinId: true, // 参会ID
        // num: true, // 邀请人数
        // phone: false, // 手机号
        // email: false, // 邮箱
        // jobNumber: false, // 工号
        // watchDuration: true, // 观看时长
        // liveWatchDuration: true, // 直播观看时长
        // vodWatchDuration: true, // 回放观看时长
        // client: true, // 观看终端
        // location: true, // 地理位置
        // inviteType: true, // 邀请方式
        // enterTime: true, // 进入时间
        // channelName: true // 渠道来源
      },
      rules: {
        export_fields: [
          { validator: validateFields, trigger: 'change' } // 自定义其它验证, 20250526这里注释掉改由服务端校验
        ]
      }
    };
  },
  // 使用es6-string-html定义模板
  template: /*html*/ `
     <div class="message-content">
        <p class="message-tip">${i18n.t('lang.k_058002')}</p>
        <vh-form :model="formData" :rules="rules" label-width="70px" class="message-content-form">
          <vh-form-item label="${i18n.t('lang.k_058003')}" prop="export_fields" style="margin-bottom:0;">
            <vh-checkbox-group v-model="formData.export_fields">
              <vh-checkbox label="nickname" name="export_fields">${i18n.t('lang.k_058004')}</vh-checkbox>
              <vh-checkbox label="nicknameUpdated" name="export_fields">${i18n.t('lang.k_058005')}</vh-checkbox>
              <vh-checkbox label="wechatOpenId" name="export_fields">${i18n.t('lang.k_058006')}</vh-checkbox>
              <vh-checkbox label="joinId" name="export_fields">${i18n.t('lang.k_058007')}</vh-checkbox>
              <vh-checkbox label="num" name="export_fields">${i18n.t('lang.k_058008')}</vh-checkbox>
              <vh-checkbox label="phone" name="export_fields">${i18n.t('lang.k_058009')}</vh-checkbox>
              <vh-checkbox label="email" name="export_fields">${i18n.t('lang.k_058010')}</vh-checkbox>
              <vh-checkbox label="jobNumber" name="export_fields">${i18n.t('lang.k_058011')}</vh-checkbox>
              <vh-checkbox label="watchDuration" name="export_fields">${i18n.t('lang.k_058012')}</vh-checkbox>
              <vh-checkbox label="liveWatchDuration" name="export_fields">${i18n.t('lang.k_058013')}</vh-checkbox>
              <vh-checkbox label="vodWatchDuration" name="export_fields">${i18n.t('lang.k_058014')}</vh-checkbox>
              <vh-checkbox label="client" name="export_fields">${i18n.t('lang.k_058015')}</vh-checkbox>
              <vh-checkbox label="location" name="export_fields">${i18n.t('lang.k_058016')}</vh-checkbox>
              <vh-checkbox label="inviteType" name="export_fields">${i18n.t('lang.k_058017')}</vh-checkbox>
              <vh-checkbox label="enterTime" name="export_fields">${i18n.t('lang.k_058018')}</vh-checkbox>
              <vh-checkbox label="channelName" name="export_fields">${i18n.t('lang.k_058019')}</vh-checkbox>
            </vh-checkbox-group>
          </vh-form-item>
        </vh-form>
      </div>
  `
});
function getExportFields() {
  const cacheExportFieldsStr = localStorage.getItem('invite_rank_export_fields');
  if (cacheExportFieldsStr) {
    const cacheExportFields = cacheExportFieldsStr.split(',');
    return cacheExportFields.length > 0 ? cacheExportFields : DEFAULT_EXPORT_FIELDS;
  } else {
    return DEFAULT_EXPORT_FIELDS;
  }
}
function setExportFieldsToCache(export_fields) {
  if (Array.isArray(export_fields)) {
    localStorage.setItem('invite_rank_export_fields', export_fields.join(','));
  } else {
    localStorage.setItem('invite_rank_export_fields', export_fields);
  }
}
export default async function useInviteRankChoice(h, options) {
  if (!options) options = {};
  options.confirmHook = function (formData) {
    setExportFieldsToCache(formData.export_fields);
  };
  options.cancelHook = function (formData) {
    setExportFieldsToCache(formData.export_fields);
  };
  return useCustomMessageBox(h, MessageBoxConent, options);
}